import { Typography } from "@packages/ds";
import styled from "styled-components";

import { AddButton as DsAddButton, Link as DsLink } from "ds/Button";
import * as Sticker from "ds/Sticker";

export const EmptyDomainsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  color: var(--section-ebony-light-color, var(--ebony-light));
  background: var(--section-snow-background-color, var(--snow));
  min-height: 372px;

  padding: 20px 32px 14px 32px;
  .copyable {
    width: 80%;
  }
`;

export const Title = styled(Typography.Title)`
  padding-top: 60px;
  padding-bottom: 16px;
  font-size: 18px;
`;

export const SubTitle = styled(Typography.BodyText)`
  padding-left: 170px;
  padding-right: 170px;
  padding-bottom: 40px;
  text-align: center;
`;

export const AddButton = styled(DsAddButton)`
  float: right;
`;

export const StickerRoot = styled(Sticker.Root)`
  margin-bottom: 32px;
`;

export const MainContainer = styled.div``;

export const ContactSupport = styled.p`
  margin: 291px 0 24px 0;
  font-size: 14px;
`;

export const Link = styled(DsLink)`
  text-transform: none;
`;
